import React from 'react';
import ThemeToggle from './ThemeToggle';

const NavBar = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'mapa', label: 'Mapa', icon: '🗺️' },
    { id: 'materias', label: 'Materias', icon: '📚' },
    { id: 'agenda', label: 'Agenda', icon: '📅' }
  ];

  return (
    <nav className="nav-bar" style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 20px',
      backgroundColor: 'var(--bg-secondary)',
      borderBottom: '1px solid var(--border-color)',
      boxShadow: 'var(--shadow-small)'
    }}>
      <div className="nav-links" style={{
        display: 'flex',
        gap: '0'
      }}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 20px',
              border: 'none',
              backgroundColor: activeTab === tab.id ? 'var(--accent-color)' : 'transparent',
              color: activeTab === tab.id ? 'var(--text-inverse)' : 'var(--text-primary)',
              cursor: 'pointer',
              fontSize: '0.9em',
              fontWeight: activeTab === tab.id ? '600' : '500',
              transition: 'all 0.2s ease',
              borderRadius: '8px 8px 0 0',
              borderBottom: activeTab === tab.id ? '3px solid var(--accent-color)' : 'none'
            }}
          >
            <span className="nav-icon" style={{ fontSize: '1.1em' }}>{tab.icon}</span>
            <span className="nav-text">{tab.label}</span>
          </button>
        ))}
      </div>
      <ThemeToggle />
    </nav>
  );
};

export default NavBar; 